import { OrganizationMemberRole } from './organizationMemberProfile';
import { ProjectMemberRole } from './projectMemberRole';
export const AllowedEmailDomainsRoles = [
    OrganizationMemberRole.EDITOR,
    OrganizationMemberRole.INTERACTIVE_VIEWER,
    OrganizationMemberRole.VIEWER,
    OrganizationMemberRole.MEMBER,
];
export function isAllowedEmailDomainsRole(role) {
    return AllowedEmailDomainsRoles.includes(role);
}
export const AllowedEmailDomainProjectRoles = [
    ProjectMemberRole.EDITOR,
    ProjectMemberRole.INTERACTIVE_VIEWER,
    ProjectMemberRole.VIEWER,
];
export function isAllowedEmailDomainProjectRole(role) {
    return AllowedEmailDomainProjectRoles.includes(role);
}
//# sourceMappingURL=organization.js.map